import { isNaN } from 'lodash';

/**
 * Converts a number to a stringified number with the specified number of decimals and
 * optional comma separations. Changes in number's significance can cause rounding
 *
 * example:
 * formatNumber(1000.999, 1, true) // '1,001.0'
 *
 * @param {number} number - number to format
 * @param {number} decimalCount - number of decimal places
 * @param {bool} hasCommas - if thousands should be separated with commas
 */
export default function formatNumber(value, decimalCount = 2, hasCommas = true, trimTrailingZeros = false) {
    if (value === null || isNaN(Number(value))) {
        return '';
    }

    const number = Number(value) || 0;
    const comma = hasCommas ? ',' : '';
    const negativeSign = number < 0 ? '-' : '';

    // Convert number to a string with corrected decimal places
    let stringifiedNumber = Math.abs(number).toFixed(decimalCount);


    // IF not adding commas, then we're done
    if (!hasCommas) {
        if (trimTrailingZeros) {
            stringifiedNumber = stringifiedNumber.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1');
        }
        return negativeSign + stringifiedNumber;
    }

    // ELSE we need to add commas

    // Get the whole part of the number that needs comma formatting
    const wholePart = parseInt(stringifiedNumber, 10).toString();

    // Save the decimal places to add on later
    const decimalPart = decimalCount
        ? stringifiedNumber.slice((decimalCount + 1) * -1)
        : '';

    // Get the number of digits (really characters) of the number before the first comma
    const countBeforeFirstComma = (wholePart.length > 3) ? wholePart.length % 3 : 0;

    // Save the initial characters of the number before the first commas
    const wholePartInitial = countBeforeFirstComma ? wholePart.substr(0, countBeforeFirstComma) + comma : '';

    // Use Regex replace to format the rest of the whole part with commas
    const wholePartLater = wholePart.substr(countBeforeFirstComma).replace(/(\d{3})(?=\d)/g, `$1${comma}`);


    // String concat all the bits back together
    let result = negativeSign + wholePartInitial + wholePartLater + decimalPart;

    if (trimTrailingZeros) {
        result = result.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1');
    }

    return result;
}
